var CustomTextField = function (config) {
  jsGrid.Field.call(this, config);
};

CustomTextField.prototype = new jsGrid.Field({
  css: "text-field", //for future reference
  //		readOnly: false,

  filterTemplate: function () {
    if (!this.filtering) return "";

    var grid = jsGrid,
      $result = (this.filterControl = this._createTextBox());

    if (this.autosearch) {
      $result.on("keypress", function (e) {
        if (e.which === 13) {
          grid.search();
          e.preventDefault();
        }
      });
    }

    return $result;
  },

  insertTemplate: function () {
    if (!this.inserting) return "";

    return (this.insertControl = this._createTextBox());
  },

  editTemplate: function (value) {
    if (!this.editing) return this.itemTemplate.apply(this, arguments);

    var $result = (this.editControl = this._createTextBox());
    $result.val(value);
    return $result;
  },

  filterValue: function () {
    return this.filterControl.val();
  },

  insertValue: function () {
    return this.insertControl.val();
  },

  editValue: function () {
    return this.editControl.val();
  },

  _createTextBox: function () {
    return $("<input>")
      .attr({
        type: "text",
        "aria-label": "grid text",
      })
      .prop("readonly", !!this.readOnly);
  },
});

// @todo Implement functions below for selecting and manipulating table rows via checkboxes

module.exports = CustomTextField;
